package kz.dentalcrm.app.screens.service_categories.edit

import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.error_message
import dentalcrm.composeapp.generated.resources.snackbar_service_category_deleted
import dentalcrm.composeapp.generated.resources.snackbar_service_category_updated
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.domain.ServicesRepository
import kz.dentalcrm.app.screens.service_categories.edit.mvi.EditServiceCategoryViewEvent
import kz.dentalcrm.app.screens.service_categories.edit.mvi.EditServiceCategoryViewSideEffect
import kz.dentalcrm.app.screens.service_categories.edit.mvi.EditServiceCategoryViewState
import kz.dentalcrm.app.theme.SnackbarController
import kz.dentalcrm.app.theme.SnackbarEvent
import org.jetbrains.compose.resources.getString
import org.koin.core.component.inject

class EditServiceCategoryViewModel :
    BaseStateViewModel<EditServiceCategoryViewEvent, EditServiceCategoryViewState, EditServiceCategoryViewSideEffect>() {

    private val servicesRepository: ServicesRepository by inject()

    override fun setInitialState() = EditServiceCategoryViewState()

    override fun handleEvents(event: EditServiceCategoryViewEvent) {
        when (event) {
            is EditServiceCategoryViewEvent.EditCategory -> {
                editCategory(event.category.id.toString(), event.name)
            }
            is EditServiceCategoryViewEvent.DeleteCategory -> {
                deleteCategory(event.category.id.toString())
            }
            EditServiceCategoryViewEvent.Reset -> {
                setState { copy(screenState = EditServiceCategoryViewState.ScreenState.Idle) }
            }
        }
    }

    private fun editCategory(id: String, name: String) {
        setState { copy(screenState = EditServiceCategoryViewState.ScreenState.Editing) }
        launch(Dispatchers.Default) {
            when (val result = servicesRepository.updateServiceCategory(id.toInt(), name)) {
                is Result.Success -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.snackbar_service_category_updated), SnackbarEvent.SnackbarType.Green))
                    setState { copy(screenState = EditServiceCategoryViewState.ScreenState.Edited) }
                }
                is Result.Error -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = EditServiceCategoryViewState.ScreenState.Error(
                                error = result.message ?: "Error editing category"
                            )
                        )
                    }
                }
                else -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = EditServiceCategoryViewState.ScreenState.Error(
                                error = "Unknown error"
                            )
                        )
                    }
                }
            }
        }
    }

    private fun deleteCategory(id: String) {
        setState { copy(screenState = EditServiceCategoryViewState.ScreenState.Deleting) }
        launch(Dispatchers.Default) {
            when (val result = servicesRepository.deleteServiceCategory(id)) {
                is Result.Success -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.snackbar_service_category_deleted), SnackbarEvent.SnackbarType.Green))
                    setState { copy(screenState = EditServiceCategoryViewState.ScreenState.Deleted) }
                }
                is Result.Error -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = EditServiceCategoryViewState.ScreenState.Error(
                                error = result.message ?: "Error deleting category"
                            )
                        )
                    }
                }
                else -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = EditServiceCategoryViewState.ScreenState.Error(
                                error = "Unknown error"
                            )
                        )
                    }
                }
            }
        }
    }
}
